import client from './AxiosClient'

const productService = {
    filter : (params) => client.get("/products/filter", { params }),
    updateStatus : (productId) => client.patch(`products/toggle-active/${productId}`),
    getDetail : (productId) => client.get(`/products/detail?productId=${productId}`),

}

export default productService;